import React from 'react';
import { Route } from "react-router-dom";
import EntityInvoicesList from './entity_invoices.list';
import EntityInvoicesView from './entity_invoices.view';


const EntityInvoicesRouter = ({ match }) => (
  <div>
    <Route path={`${match.path}/:id`} component={EntityInvoicesView} />
    <Route
      exact
      path={match.path}
      component={EntityInvoicesList}
    />
  </div>
);

export default EntityInvoicesRouter;
